import {Component, Input, OnInit} from '@angular/core';
import { ModalController, IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonNote, IonGrid, IonRow, IonCol, IonButton } from '@ionic/angular/standalone';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  ModalConditionsConfiguration,
  ModalFormConfiguration, ModalFunctionConfiguration,
  ModalTextConfiguration
} from "../../interfaces/modal-configuration-interface";
import {ModalRoleEnum} from "../../enums/modal-enum";
import { UpperCasePipe, TitleCasePipe } from '@angular/common';
import { TranslocoModule, TranslocoService, provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonNote, IonGrid, IonRow, IonCol, IonButton, FormsModule, ReactiveFormsModule, UpperCasePipe, TitleCasePipe, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class ModalComponent implements OnInit {

  @Input('form') set form(form: ModalFormConfiguration) {
    this.modalForm = form;
    this.formGroup = this.fb.group(this.modalForm);
  }

  @Input('text') set text(text: ModalTextConfiguration) {
    this.modalTitle = text?.modal_title ?? '';
    this.modal_subtitle = text?.modal_subtitle ?? null;
    this.second_modal_message = text?.second_modal_message ?? null;
    this.modalMessage = text?.modal_message ?? '';
    this.confirmButtonTextOverride = text?.confirm_button ?? null;
    this.cancelButtonTextOverride = text?.cancel_button ?? null;
  }

  @Input('conditions') set conditions(conditions: ModalConditionsConfiguration) {
    this.isConfirmButtonVisible = !!(conditions?.confirm_button ?? true);
    this.isCancelButtonVisible = !!(conditions?.cancel_button ?? true);
    this.areTermsAndConditionsVisible = !!(conditions?.terms_conditions ?? false);
    this.isHiddenForm = !!(conditions?.hidden_form ?? false);
  }

  @Input('functions') set functions(functions: ModalFunctionConfiguration) {
    if(!!functions.confirm_function) {
      this.confirmFunction = functions.confirm_function
    } else {
      this.confirmFunction = this.confirm
    }
  }

  modalForm: any;
  formGroup: FormGroup = new FormGroup<any>({});
  modalTitle: string = '';
  modal_subtitle: string | undefined | null;
  second_modal_message: string | undefined | null;
  modalMessage: string = '';
  private confirmButtonTextOverride: string | null = null;
  private cancelButtonTextOverride: string | null = null;
  isConfirmButtonVisible = true;
  isCancelButtonVisible = true;
  areTermsAndConditionsVisible = false;
  isHiddenForm = false;
  confirmFunction: (form: any) => void;

  get confirmButtonText(): string {
    return this.confirmButtonTextOverride ?? this.transloco.translate('common.action.confirm');
  }

  get cancelButtonText(): string {
    return this.cancelButtonTextOverride ?? this.transloco.translate('common.action.cancel');
  }

  get errorMessagePasswordPattern(): string {
    return this.transloco.translate('shared.generic_modal.passwordPatternError');
  }

  get errorMessageEmailPattern(): string {
    return this.transloco.translate('shared.generic_modal.emailPatternError');
  }

  constructor(private modalController: ModalController,
              private fb: FormBuilder,
              private transloco: TranslocoService) {
    this.confirmFunction = this.confirm;
  }

  ngOnInit() {
  }

  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirm(form: FormGroup) {
    return this.modalController.dismiss(form.value, ModalRoleEnum.CONFIRM);
  }

  getFormCtrl(field: string) {
    return this.formGroup?.get(field) as FormControl;
  }

  getFields() {
    return (!!this.modalForm && !this.isHiddenForm) ? Object.keys(this.modalForm) : null;
  }

  upperFirst(text: string) {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
  }

  upperCase(text: string) {
    return text?.toUpperCase();
  }

}

